const statuses = [
  { value: true, label: 'Open' },
  { value: false, label: 'Closed' },
];

const priorities = [
  { value: 'URGENT', label: 'Urgent' },
  { value: 'HIGH', label: 'High' },
  { value: 'MEDIUM', label: 'Medium' },
  { value: 'LOW', label: 'Low' },
];

export { statuses, priorities };
